import { render } from "./Trendiencer.vue?vue&type=template&id=422287db"
import script from "./Trendiencer.vue?vue&type=script&lang=js"
export * from "./Trendiencer.vue?vue&type=script&lang=js"

import "./Trendiencer.vue?vue&type=style&index=0&id=422287db&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__